import { takeLatest, put, call, select, take } from 'redux-saga/effects';
import { getAllMetaData, updateSettingsMetaDataFromCurrent, getAvailableLanguagesIfNeeded } from './sagas';
import {
  GET_ALL_META_DATA,
  UPDATE_SETTINGS_META_DATA,
  GETTING_ALL_META_DATA_FAILED,
  UPDATING_SETTINGS_META_DATA_FAILED,
  UPDATING_SETTINGS_META_DATA_SUCCEEDED,
  GET_AVAILABLE_LANGUAGES
} from './actions';
import { actions as UserActions } from 'store/user';
import { actions as userMessaging } from 'store/userMessaging';

/* Helper Sagas */

function* waitForUserReady() {
  const userReady = yield select(store => store.user.ready);
  if (!userReady) {
    yield take(UserActions.LOGIN_READY);
  }
}

/* APP FLOW - Campaigns */
function* AllMetaDataGetSaga() {
  yield takeLatest(GET_ALL_META_DATA, function*(action) {
    yield call(waitForUserReady);
    yield call(getAllMetaData);
  });
}

function* MetaDataFailuresSaga() {
  yield takeLatest(
    [GETTING_ALL_META_DATA_FAILED, UPDATING_SETTINGS_META_DATA_FAILED],
    function*(action) {
      yield put(
        userMessaging.setMessageForFailedAction({
          type: action.type,
          error: action.payload
        })
      );
    }
  );
}

function* SettingsMetaDataUpdateSaga() {
  yield waitForUserReady();
  yield takeLatest(
    UPDATE_SETTINGS_META_DATA,
    updateSettingsMetaDataFromCurrent
  );
}

function* SettingsMetaDataUpdateSuccessSaga() {
  yield takeLatest(UPDATING_SETTINGS_META_DATA_SUCCEEDED, getAllMetaData);
}

function* GetAvailableLanguagesSaga() {
  yield takeLatest(GET_AVAILABLE_LANGUAGES, getAvailableLanguagesIfNeeded);
}

export default [
  AllMetaDataGetSaga,
  SettingsMetaDataUpdateSaga,
  MetaDataFailuresSaga,
  SettingsMetaDataUpdateSuccessSaga,
  GetAvailableLanguagesSaga
];
